import {Component, OnInit, AfterViewInit, Input, Output, EventEmitter, ElementRef, HostListener} from '@angular/core';
import {Router, ActivatedRoute} from '@angular/router';
import {CommonService} from '../common.service';
import {ApiService} from '../api.service';
import {AppChartsService} from './app-charts.service';

@Component({
	selector: 'app-component-charts',
	templateUrl: './app-charts.component.html',
	styleUrls: ['./app-charts.component.css']
})

export class AppChartsComponent implements OnInit, AfterViewInit {

  // 图表类型
  @Input() chartsType: any;
  // 主题
  @Input() theme: any;
  // 图表数据
  @Input() chartsData: any;
  //是否训练营
  @Input() isCamp: boolean;
  //最大值
  @Input() max: number;

  // charts服务层
  appChartsService: AppChartsService;
  // 图表主题
  chartsTheme: any;
  // 图表配置
  chartsOpt: any;

  //前后测报告图表Theme配色
  surveyThemeColor: any = ['#BABDD0', '#7297E6'];

  // 前后测报告图表Theme
  surveyTheme: any = {
    // 基础样式
    base:{
      //居中显示
      center: ['50%', '50%'],
      // 缩放
      radius: window.screen.width > 320 ? 80 : 70,
      //labelStyle
      name: {
        textStyle: {
          color: '#4A4A4A',
          fontSize: 10,
          backgroundColor: 'rgba(0,0,0,0)',
          padding: [0, 0]
        },
        formatter: function (text) {
          if(text.length>7){
            text = text.replace(/\S{7}/g, function(match){
                return match + '\n';
            });
          }
          return text;
        }
      },
      //坐标线Style
      axisLine: {
        show: false,
        lineStyle: {}
      },

      //分割数量
      splitNumber: 6,
      //背景Style
      splitArea : {
        show : true,
        areaStyle : {
          color: ["#fff"]
        }
      },
      // 线框样式
      splitLine : {
        show : true,
        lineStyle : {
          width : 1,
          color : '#e8e8e8'
        }
      },
    },

    //indicator坐标数值Style
    indicatorAxisLabel: {
      show: true,
      fontSize: 10,
      color: '#999',
      showMaxLabel: true, //显示最大值
      showMinLabel: true, //显示最小数字
      z: 10
    },


    series: {
      //symbolStyle
      symbol: "none",
      //itemStyle
      seriesDataStyle: [
        // {
        //   // 区域Style
        //   areaStyle: {
        //     type: 'default',
        //     color:"#BABDD0",
        //     // color: "#F3F4F8",
        //     opacity: 0.1
        //   },
        //   // 线框Style
        //   lineStyle: {
        //     width: 2,
        //     color:"#BABDD0"
        //   }
        // },
        // {
        //   // 区域Style
        //   areaStyle: {
        //     type: 'default',
        //     color:"#7297E6",
        //     // color: "#E3EAFA",
        //     opacity: 0.1
        //   },
        //   // 线框Style
        //   lineStyle: {
        //     width: 2,
        //     color:"#7297E6"
        //   }
        // }
      ]
    }

  };


  constructor(
              private commonService: CommonService,
              private apiService: ApiService,
              private route: ActivatedRoute,
              private router: Router,
              private el: ElementRef
  ) {}

  ngOnInit() {

    this.appChartsService = new AppChartsService();
    this.max = this.max ? this.max : 24;

    // 根据传入的主题配置图表主题
    this.chartsTheme = {
      "survey": this.surveyTheme
    }[this.theme] || this.surveyTheme;

    // 配置颜色
    this.setThemeColor(this.chartsData);

    if(this.isCamp){
      this.surveyTheme.base.radius = window.screen.width > 320 ? 95 : 80;
      this.surveyTheme.base.splitLine['lineStyle']['type'] = 'dotted';
      this.surveyTheme.base.splitLine['lineStyle']['color'] = '#b8b8b8';
      this.surveyTheme.base.axisLine.show = true;
      this.surveyTheme.base.axisLine['lineStyle']['type'] = 'dotted';
      this.surveyTheme.series.symbol = 'circle';
    }

    // 根据主题设置配置
    this.chartsOpt = this.appChartsService.setChartsAttribute(this.chartsTheme, this.chartsType, this.chartsData, this.max);
  }

  ngAfterViewInit(){
    this.appChartsService.chartsInit(this.chartsOpt, this.el.nativeElement.querySelector('#' + this.chartsType + 'Charts'));
  }

  // 配置颜色
  setThemeColor(data){
    let seriesDataStyleSimple;

    if(data.length > 1){
      seriesDataStyleSimple = [];
      for(let i = 0, len = data.length; i<len; i+=1){
        seriesDataStyleSimple[i] = {};
        if(this.isCamp){
          seriesDataStyleSimple[i]["color"] = this.surveyThemeColor[i];
        }
        seriesDataStyleSimple[i]["areaStyle"] = {};
        seriesDataStyleSimple[i]["lineStyle"] = {};
        seriesDataStyleSimple[i]["areaStyle"]["type"] = 'default';
        seriesDataStyleSimple[i]["areaStyle"]["color"] = this.surveyThemeColor[i];
        seriesDataStyleSimple[i]["areaStyle"]["opacity"] = 0.1;
        seriesDataStyleSimple[i]["lineStyle"]["color"] = 2;
        seriesDataStyleSimple[i]["lineStyle"]["color"] = this.surveyThemeColor[i];
        this.surveyTheme.series.seriesDataStyle = seriesDataStyleSimple;
      }
    }else{
      seriesDataStyleSimple = {};
      if(this.isCamp){
        seriesDataStyleSimple["color"] = this.surveyThemeColor[1];
      }
      seriesDataStyleSimple["areaStyle"] = {};
      seriesDataStyleSimple["lineStyle"] = {};
      seriesDataStyleSimple["areaStyle"]["type"] = 'default';
      seriesDataStyleSimple["areaStyle"]["color"] = this.surveyThemeColor[1];
      seriesDataStyleSimple["areaStyle"]["opacity"] = 0.1;
      seriesDataStyleSimple["lineStyle"]["color"] = 2;
      seriesDataStyleSimple["lineStyle"]["color"] = this.surveyThemeColor[1];
      this.surveyTheme.series.seriesDataStyle.push(seriesDataStyleSimple);
    }

  }


}



// WEBPACK FOOTER //
// ./src/app/app-charts/app-charts.component.ts